// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2uvwP","search":"Settings_search__39HD5","filter":"Settings_filter__BQfIw"};